export class RouteAsPerMap {

    refNo: number;
    onDateTime: string;
    serviceManID: string;
    weatherCondition: string;
    trafficCondition: string;
    distance: string;
    duration: string;
    fromLocCode: string;
    toLocCode: string;
    usedFor: string;
    usedForRefNo: string;
    tripNo: number;
    deliverySequenceNo: number;
    trafficDuration: string;

}
